import { CategoriesSelectDto, CategorySelectDto } from '@@types/api.types';
import { ApiErrorWrapper, useApi } from '@hooks/api.hook';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from './keys';

export const useGetCategories = () => {
  const { apiGet } = useApi();

  return useQuery<CategorySelectDto[], ApiErrorWrapper>({
    queryFn: async () => {
      const result = await apiGet<CategoriesSelectDto>({
        path: '/v1/data/categories',
      });
      return result.categories;
    },
    queryKey: queryKeys.category.getCategories,
  });
};
